require("@babel/polyfill");

import "./navbar.js";
import "./login.js";
import "./account.js";
import "./account-password.js";
import "./user-list.js";
import "./user-edit.js";
import "./config-list.js";
import "./banner-list.js";
import "./banner-edit.js";
import "./banner-items.js";
import "./post-list.js";
import "./post-editor.js";
import "./post-featured.js";
import "./posttype-edit.js";
